<template>
  <div id="login" class="login-background-color">
    <img src="@/assets/logo.png" style="height: 250px; margin: 25px;" />
    <div style="color: white;">
      <p>Philips Care Portal</p>
    </div>
    <footer class="login-footer" >
      <div class="is-inverted" style="color: white; margin: 0 0 0 auto">
        Ver.{{ version }}
      </div>
      <br> 
      <div style="color: #FFF;">
        <span class="nav-item">
          <button class="button custom-button" type="button" slot="trigger" @click="ssologin">
            <b-icon icon="login"></b-icon>
            <span>ログイン</span>
          </button>
          <!-- <button class="button is-primary custom-button" type="button" slot="trigger" @click="ssologin">
            <b-icon icon="login"></b-icon>
            <span>ログイン</span>
          </button> -->
        </span>
      </div>
    </footer>
    <!-- <div style="height: 30px" />
    <div style="height: 20px;" /> -->
  </div>
</template>

<script>
import Vue from "vue";
import { role } from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";

export default {
  name: "SSOLogin",
  data() {
    var env = this.$store.state.env;
    var version = this.$store.state.version;
    var dateUpdated = this.$store.state.dateUpdated;
    return {
      env: env,
      role: role,
      mailAddress: "",
      password: "",
      passPhrase: "",
      isActive: true,
      version,
      dateUpdated,
      view: "login",
      notice: "",
      userInfo: null,
      passPhraseErrorCount: 0,
      introductionQuery:
        this.$route.query && this.$route.query.query
          ? this.$route.query.query
          : "",
    };
  },
  methods: {
    login: function () {
      this.isActive = false;
      console.log("login called.");
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch("login", {
              mail: this.mailAddress,
              password: this.password,
            })
            .then((result) => {
              console.log(result);
              if (result != null && result.status === 200) {
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                //パスフレーズ認証
                let passphraseFlag = this.userInfo.passphraseFlag;
                if (passphraseFlag) {
                  this.isActive = true;
                  this.view = "passPhrase";
                } else {
                  this.goToMenu();
                }
              } else if (
                result != null &&
                (result.status === 400 ||
                  result.status === 401 ||
                  result.status === 500)
              ) {
                var message = "予期しないエラーが発生しました。";
                if (result.response.body) {
                  message = result.response.body.message;
                } else if (result.message) {
                  message = result.message;
                }
                this.showErrorMessage(message);
                this.isActive = true;
              } else {
                this.isActive = true;
                this.showErrorMessage("予期しないエラーが発生しました。");
              }
            })
            .catch((error) => {
              this.isActive = true;
            });
        } else {
          this.isActive = true;
        }
      });
    },
    ssologin: function () {
      this.isActive = false;
      const isSSOLogin = this.$store.state.isSSOLogin;

      if (!isSSOLogin){
        alert(
            "パスワード認証ログイン画面よりログインしてください。"
        );
        return
      }
      console.log("ssologin called.");
      this.$store.dispatch("ssoLogin", {
        mail: this.mailAddress,
        isSSOLogin:isSSOLogin 
      });      
    },
    loginAreaEnter: function() {
      if(this.mailAddress && this.password){
        this.login();
      }
    },
    passwordInit: function (event) {
      console.log("passwordInit called.");
      this.$router.push(this.createPwdInitParam());
    },
    comfirmPassPhrase: function () {
      //パスフレーズ認証
      this.isActive = false;
      console.log("comfirmPassPhrase called.");
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch("authPassPhrase", {
              mail: this.mailAddress,
              passPhrase: this.passPhrase,
            })
            .then((result) => {
              console.log(result);
              if (result != null && result.status === 200) {
                //OKだったらメニューへ遷移
                this.goToMenu();
              } else if (result != null && result.status === 401) {
                //認証失敗
                if (this.passPhraseErrorCount > 4) {
                  //メッセージ（5回失敗しました。再度ログイン画面に戻ります。）
                  this.showErrorMessage(
                    "試行回数が制限に達しました。ログイン画面に戻ります。"
                  );
                  this.passPhraseErrorCount = 0;
                  this.view = "login";
                } else {
                  //メッセージ（パスフレーズが違います）
                  this.showErrorMessage("パスフレーズが違います。");
                  this.passPhraseErrorCount += 1;
                }
                this.isActive = true;
              } else {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。");
                this.isActive = true;
              }
            })
            .catch((error) => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。");
              this.isActive = true;
            });
        } else {
          this.isActive = true;
        }
      });
    },
    passPhraseAreaEnter: function() {
      if(this.passPhrase){
          this.comfirmPassPhrase();
      }
    },
    back: function (event) {
      this.password = "";
      this.view = "login";
    },
    goToMenu: function () {
      if (this.userInfo.passwordForceChange) {
        //パスワード強制変更画面
        this.$router.push(this.createPasswordForceChangeParam());
      } else {
        let roleId = this.userInfo.roleId;
        if (
          roleId == this.role.role_admin ||
          roleId == this.role.role_headOffice ||
          roleId == this.role.role_headOffice_sales ||
          roleId == this.role.role_headOffice_division ||
          roleId == this.role.role_headOffice_sw ||
          roleId == this.role.role_salesOffice ||
          roleId == this.role.role_psc ||
          roleId == this.role.role_kawagoe ||
          roleId == this.role.role_kawagoe_cpap ||
          roleId == this.role.role_call_center ||
          roleId == this.role.role_headOffice_call ||
          roleId == this.role.role_ndss
        ) {
          //内部ユーザー
          this.$router.push({ path: "/philips/home" });
        } else {
          //外部ユーザー
          if (this.introductionQuery) {
            // 転院紹介
            this.isActive = false;
            var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.$store
              .dispatch("verifyKeyForIntroductionRequestAuth", {
                query: this.introductionQuery,
                token: userInfo.token,
              })
              .then((result) => {
                if (result != null && result.status === 200) {
                  if (result.body.resultDownload) {
                    this.goToResultDownload(result.body.resultDownload);
                  } else {
                    this.goToRequest(
                      result.body.prekind,
                      result.body.serviceId,
                      result.body.receptionNo
                    );
                  }
                } else if (result != null && result.status === 400) {
                  this.isActive = true;
                  this.showErrorMessage(result.response.body.message);
                } else {
                  this.isActive = true;
                  this.showErrorMessage("予期しないエラーが発生しました。");
                }
              });
          } else {
            this.$router.push({ path: "/guest/home" });
          }
        }
      }
    },
    createPasswordForceChangeParam: function () {
      var res = {
        name: "AppPasswordForceChange",
        params: {
          isInitialPassword: this.userInfo.initialPassword,
          currentpassword: this.password,
        },
      };
      if (this.introductionQuery) {
        res.query = {
          query: this.introductionQuery,
        };
      }
      return res;
    },
    createPwdInitParam: function () {
      var res = {
        path: "/pwdInit",
      };
      if (this.introductionQuery) {
        res.query = {
          query: this.introductionQuery,
        };
      }
      return res;
    },
    goToRequest: async function (prekind, serviceId, receptionNo) {
      var loadMasterList = [];
      loadMasterList.push(this.getOfficeMaster())
      loadMasterList.push(this.getStatusMaster())
      loadMasterList.push(this.getAuthMaster())
      loadMasterList.push(this.getKindMaster())
      loadMasterList.push(this.getChoiceMaster())

      var userInfo = this.getUserInfo();
      if (this.isEnableService(userInfo.useServiceId, service.cpap)) {
        loadMasterList.push(this.getPrescriptionHardware())
        loadMasterList.push(this.getCpapStatusMaster())
        loadMasterList.push(this.getCpapCommonMaster())
        loadMasterList.push(this.getCpapItemMaster())
      }

      var appVue = this.$root.$children[0]
      appVue.loadingStart()

      await Promise.all (loadMasterList)
      .then ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み 正常終了");
      })
      .catch ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み エラー終了\nerrorlog : " + response.message);
      });

      this.$router.push({
        name: this.getRequestComponent(serviceId),
        params: {
          kind: prekind,
          receiptNumber: receptionNo,
          id: prekind == "holder" ? "easy" : "full", // PSG解析
          introduction: true,
        },
      });
      return;
    },
    goToResultDownload: function (result) {
      this.$router.push({
        name: "ResultDownload",
        params: {
          result: result,
        },
        query: {
          query: this.introductionQuery,
        },
      });
      return;
    },
  },
  computed: {},
  mounted: function () {
    this.$store
      .dispatch("getAnnouncement", {
        type: 0,
      })
      .then((result) => {
        console.log(result);
        if (result != null && result.status === 200) {
          this.notice = result.body.contents;
        } else if (result != null && result.status === 401) {
          this.notice = "お知らせを取得できませんでした。";
        } else {
          this.notice = "お知らせを取得できませんでした。";
        }
      })
      .catch((error) => {
        this.notice = "お知らせを取得できませんでした。";
      });
  },
  created() {
    console.log("mounted get mail")
    const query = new URLSearchParams(window.location.search);
    const token = query.get('SSOtoken');
    const isSSOLogin = this.$store.state.isSSOLogin;

    if (isSSOLogin && token){
      this.$store.dispatch("ssoLoginInfo", { isSSOLogin:isSSOLogin })
        .then((result) => {
          console.log(result);
          if (result != null && result.status === 200) {
              this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
              this.goToMenu();
          } else if (
            result != null &&
            (result.status === 400 ||
              result.status === 401 ||
              result.status === 500)
          ) {
            var message = "予期しないエラーが発生しました。";
            if (result.response.body) {
              message = result.response.body.message;
            } else if (result.message) {
              message = result.message;
            }
            this.showErrorMessage(message);
            this.isActive = true;
          } else {
            this.isActive = true;
            this.showErrorMessage("予期しないエラーが発生しました。");
          }
        })
        .catch((error) => {
          this.isActive = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

.nav {
  z-index: 10;
}

.background {
  background: linear-gradient(
    -35deg,
    rgb(0, 50, 93) 20%,
    rgb(0, 119, 205) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 50, 93) 20%,
    rgb(0, 119, 205) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 50, 93) 20%,
    rgb(0, 119, 205) 100%
  );
  height: auto;
}

.background_dev {
  background: linear-gradient(
    -35deg,
    rgb(230, 18, 194) 20%,
    rgb(240, 153, 225) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(230, 18, 194) 20%,
    rgb(240, 153, 225) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(230, 18, 194) 20%,
    rgb(240, 153, 225) 100%
  );
  height: auto;
}

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "light": (
    $light,
    $light-invert,
  ),
  "dark": (
    $dark,
    $dark-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
.passphrase_txt {
  margin-left: 30px;
  margin-bottom: 32px;
  text-align: left;
}
.modal-card-head,
.modal-card-foot {
  background: linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
}
.modal-card-title {
  color: whitesmoke;
}

ul {
  text-align: center;
  margin-left: -10px;
  font-size: 0; /* タグ改行時の空白防止 */
}

ul li {
  display: inline-block;
  margin-left: 30px;
  font-size: 14px; /* ulでサイズ0にしたのを戻す */
}
.modal-card-title {
  font-size: 1.4rem;
}
.copyright_area {
  margin-top: 10px;
}
.copyright {
  font-size: small;
}
.login-background-color {
  background: -moz-radial-gradient(#0077cd 20%, #00325d 85%);
  background: -webkit-radial-gradient(#0077cd 20%, #00325d 85%);
  background: radial-gradient(#0077cd 20%, #00325d 85%);
  min-height: 100vh;
  height: auto;
  width: 100%;
}
.login-background-color > div {
  margin: auto;
}
.login-background-color > div > p {
  color: whitesmoke;
  font-size: 35px;
  margin: 0 0 10px 0;
}
.login-footer {
  margin: 0px 0 0 0;
  width: 500px;
  display: inline-block;
}

.custom-button {
  background-color: #00325d;
  color: #fff;
  width: 300px;
  height:50px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/SSOLogin.vue